"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashPoleLoading = exports.DashPoleLoadingConfig = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const mithril_1 = require("../../mithril");
const photomeasure_button_1 = require("../../modules/photomeasure.button/photomeasure.button");
const services_1 = require("../../services");
const page_1 = require("../page");
const dashboard_banner_1 = require("./dashboard.banner");
const dashboard_style_1 = require("./dashboard.style");
const dashboard_table_1 = require("./dashboard.table");
const dashboard_table_style_1 = require("./dashboard.table.style");
exports.DashPoleLoadingConfig = {
    type: 'internal',
    name: page_1.IkePageName.dashboardPoleloading,
    path: '/dashboard/pole_loading',
    auth: {
        required: true,
    },
    layout: { nav: false, banner: true },
};
class DashPoleLoading extends page_1.IkePage {
    constructor() {
        super(exports.DashPoleLoadingConfig);
        this.poleLoadingSum = null;
    }
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.poleLoadingSum = yield services_1.Services.Dashboard.getPoleLoadingSummary();
        });
    }
    get nodes() {
        let nodes = null;
        if (!services_1.Services.Token.has(core_api_1.IkeToken.DASHBOARD_PAGE)) {
            nodes = (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.container }, (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.message }, 'No Dashboard Token'));
            return nodes;
        }
        if (this.poleLoadingSum == null) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.init();
        }
        nodes = (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.container }, [dashboard_banner_1.DashBanner.nodes, this.viewTable()]);
        return nodes;
    }
    getJobData(job) {
        let load100 = 0;
        let load75 = 0;
        let load50 = 0;
        let load0 = 0;
        let loadNA = 0;
        let jobName = job.jobName == null ? 'NULL' : job.jobName;
        let jobId = job.jobId == null ? '' : job.jobId;
        if (job.collectionLoadingSummary != null) {
            job.collectionLoadingSummary.forEach((pole) => {
                if (pole != null) {
                    if (pole.loading == null) {
                        loadNA++;
                    }
                    else {
                        const loadString = pole.loading;
                        const load = parseFloat(loadString.replace(/[^\d.-]/g, ''));
                        if (load >= 100) {
                            load100++;
                        }
                        else if (load >= 75 && load < 100) {
                            load75++;
                        }
                        else if (load >= 50 && load < 75) {
                            load50++;
                        }
                        else if (load >= 0 && load < 50) {
                            load0++;
                        }
                        else {
                            loadNA++;
                        }
                    }
                }
            });
        }
        return { load100, load75, load50, load0, loadNA, jobName, jobId };
    }
    viewTable() {
        const headers = ['   #   ', 'JOB NAME', '100+%', '99-75%', '74-50%', '49-0%', 'OTHER', 'POLES TOTAL'];
        const rows = [];
        let i = 0;
        let load100total = 0;
        let load75total = 0;
        let load50total = 0;
        let load0total = 0;
        let loadNAtotal = 0;
        if (this.poleLoadingSum != null) {
            const res = this.poleLoadingSum;
            res.forEach((tag) => {
                if (tag != null) {
                    let job = this.getJobData(tag);
                    i++;
                    load100total += job.load100;
                    load75total += job.load75;
                    load50total += job.load50;
                    load0total += job.load0;
                    loadNAtotal += job.loadNA;
                    rows.push(this.viewRow(i, job));
                }
            });
            //puts the totals at the top of the list
            rows.unshift(this.totalsRow(load100total, load75total, load50total, load0total, loadNAtotal));
            //only display if we get any pole load counts
            if (load100total + load75total + load50total + load0total + loadNAtotal > 0) {
                return dashboard_table_1.Table.view(this.viewTitle(), headers, rows);
            }
        }
        return (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.message }, 'No Data Available');
    }
    viewTitle() {
        return (0, mithril_1.m)('div', { className: dashboard_table_style_1.CSS.title }, [(0, mithril_1.m)('h6', {}, 'POLE LOADING')]);
    }
    totalsRow(load100, load75, load50, load0, loadNA) {
        const total = load100 + load75 + load50 + load0 + loadNA;
        const row = [
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, '-'),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, 'Totals:'),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, load100),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, load75),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, load50),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, load0),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, loadNA),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, total),
        ];
        return row;
    }
    viewRow(index, job) {
        const total = job.load100 + job.load75 + job.load50 + job.load0 + job.loadNA;
        const row = [
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCellFaint }, index),
            (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCellRoleActions }, [
                (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCell }, job.jobName),
                (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCellGhost }, photomeasure_button_1.PhotomeasureButton.view(job.jobId)),
            ]),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCellFaint }, job.load100),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, job.load75),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCellFaint }, job.load50),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, job.load0),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCellFaint }, job.loadNA),
            (0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, total),
        ];
        return row;
    }
}
exports.DashPoleLoading = DashPoleLoading;
tslib_1.__decorate([
    mobx_1.observable
], DashPoleLoading.prototype, "poleLoadingSum", void 0);
//# sourceMappingURL=pole.loading.page.js.map